import { render } from "./BaseColumn.vue?vue&type=template&id=24576284&ts=true"
import script from "./BaseColumn.vue?vue&type=script&lang=ts"
export * from "./BaseColumn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__